import { render } from "./Foot.vue?vue&type=template&id=35baed52&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"

import "./Foot.vue?vue&type=style&index=0&id=35baed52&scoped=true&lang=scss"

import exportComponent from "/Users/ijj/sy-website/template1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35baed52"]])

export default __exports__